import { getCookieValue } from "../get-cookie-value";

const COOKIE_NAME_E2E_EXPERIMENT_OVERRIDES = "flare-e2e-experiment-overrides";

interface Override {
  name: string;
  value: Record<string, unknown>;
}

interface Req {
  cookies?: Partial<Record<string, string>>;
  headers?: Record<string, string | string[] | undefined>;
}

export type ExperimentOverrides = Record<string, Override>;

export function getE2EExperimentOverrides(
  req?: Req,
): ExperimentOverrides | null {
  return getCookieValue(COOKIE_NAME_E2E_EXPERIMENT_OVERRIDES, req);
}
